import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from "react";
import { api, ApiClientError } from "./api";
const AuthContext = createContext(null);
export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const refresh = useCallback(async () => {
        try {
            const response = await api.me();
            setUser(response.user);
            return response.user;
        }
        catch (err) {
            if (!(err instanceof ApiClientError) || err.status !== 401) {
                console.warn("auth.refresh.failed", err);
            }
            setUser(null);
            return null;
        }
    }, []);
    useEffect(() => {
        void refresh().finally(() => setLoading(false));
    }, [refresh]);
    const signin = useCallback(async (body) => {
        const response = await api.signin(body);
        setUser(response.user);
        return response.user;
    }, []);
    const signup = useCallback(async (body) => {
        const response = await api.signup(body);
        setUser(response.user);
        return response.user;
    }, []);
    const signout = useCallback(async () => {
        await api.signout();
        setUser(null);
    }, []);
    const value = useMemo(() => ({ user, loading, refresh, signin, signup, signout }), [user, loading, refresh, signin, signup, signout]);
    return _jsx(AuthContext.Provider, { value: value, children: children });
}
export function useAuth() {
    const context = useContext(AuthContext);
    if (!context)
        throw new Error("useAuth must be used inside AuthProvider.");
    return context;
}
